var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaterialSheetDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#92999C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 23.2265L57.325 27.5015H44.5V23.2265ZM31.8962 27.5015L37 24.4377V27.5015H31.8962ZM82 27.5015H69.1825L44.3425 19.2215C43.975 17.534 42.5462 16.2515 40.75 16.2515C38.6763 16.2515 37 17.9277 37 20.0015V20.0652L24.6063 27.5015H22C19.9263 27.5015 18.25 29.1777 18.25 31.2515V35.0015C18.25 37.0715 19.9263 38.7515 22 38.7515H25.75C27.8237 38.7515 29.5 37.0715 29.5 35.0015H37V80.0015H29.5C28.465 80.0015 27.625 80.8377 27.625 81.8765C27.625 82.9115 28.465 83.7515 29.5 83.7515H52C53.035 83.7515 53.875 82.9115 53.875 81.8765C53.875 80.8377 53.035 80.0015 52 80.0015H44.5V35.0015H72.625V44.7177C70.4463 45.494 68.875 47.5565 68.875 50.0015C68.875 53.1027 71.3988 55.6265 74.5 55.6265C77.6012 55.6265 80.125 53.1027 80.125 50.0015C80.125 48.9627 79.285 48.1265 78.25 48.1265C77.215 48.1265 76.375 48.9627 76.375 50.0015C76.375 51.0327 75.5312 51.8765 74.5 51.8765C73.4688 51.8765 72.625 51.0327 72.625 50.0015C72.625 48.9665 73.4688 48.1265 74.5 48.1265C75.535 48.1265 76.375 47.2865 76.375 46.2515V35.0015H82C84.0738 35.0015 85.75 33.3215 85.75 31.2515C85.75 29.1777 84.0738 27.5015 82 27.5015Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSheetDefault);
export default __webpack_public_path__ + "static/media/material_sheet_default.716f23ca3c233fba2c61bf6a6ed80368.svg";
export { ForwardRef as ReactComponent };